import React, { useEffect } from "react";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import "./tools.css";

import one from "../../assets/awsimages/tool/aws.png";
import two from "../../assets/awsimages/tool/cloudfront.png";
import three from "../../assets/awsimages/tool/cloudwatch.png";
import four from "../../assets/awsimages/tool/db.png";
import five from "../../assets/awsimages/tool/ec2.png";
import six from "../../assets/awsimages/tool/elastic.png";
import seven from "../../assets/awsimages/tool/lambda.png";
import eight from "../../assets/awsimages/tool/pipeline.png";
import nine from "../../assets/awsimages/tool/rds.png";
import ten from "../../assets/awsimages/tool/s3.png";
import elven from "../../assets/awsimages/tool/vpc.png";
// import twele from "../../assets/awsimages/tool//testtn.png";

const clients = [
  { src: one, alt: "Apache JMeter" },
  { src: two, alt: "Appium" },
  { src: three, alt: "Appium JPG" },
  { src: four, alt: "Cucumber" },
  { src: five, alt: "Java" },
  { src: six, alt: "Jenkins" },
  { src: seven, alt: "JUnit" },
  { src: eight, alt: "LoadRunner" },
  { src: nine, alt: "Postman" },
  { src: ten, alt: "Selenium" },
  { src: elven, alt: "SoapUI" },
  // { src: twele, alt: "TestNG" },
];

function Tools() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <>
      <section style={{ marginTop: "50px" }}>
        <div className="headlines-for-all">
          <h4     data-aos="fade-up" >
            <span>Tools </span> Covered
          </h4>
          <p     data-aos="fade-up">
        Gain hands-on experience with the most in-demand AWS cloud services, tools, and architectures used to build scalable cloud solutions.
          </p>
        </div>
      </section>

      <section className="our-clients-section">
        <div className="our-clients-container">
          <motion.div
            className="our-clients-track"
            animate={{ x: ["0%", "-100%"] }}
            transition={{
              ease: "linear",
              duration: 100,
              repeat: Infinity,
            }}
          >
            {[...clients, ...clients].map((client, i) => (
              <div
                className="client-item"
                key={i}
                data-aos="fade-up"
                data-aos-delay={i * 150} // DELAY ONE-BY-ONE
              >
                <img src={client.src} alt={client.alt} />
              </div>
            ))}
          </motion.div>
        </div>
      </section>
    </>
  );
}

export default Tools;
